function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.967 4.338a.75.75 0 00-.457 1.43 2.031 2.031 0 011.398 1.77.75.75 0 001.495-.126 3.532 3.532 0 00-2.436-3.074z",
  fill: "#313D53"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.973 3.064c2.003-2.952 6.1-3.618 9.023-1.786 2.926-1.83 7.019-1.164 9.025 1.786 1.3 1.911 1.559 4.452.82 6.747l-.002.008-.002.008c-1.574 4.539-5.763 7.51-9.436 9.795a.75.75 0 01-.781.007c-3.712-2.224-7.893-5.296-9.456-9.802l-.002-.008-.003-.008C.42 7.517.675 4.976 1.973 3.064zm1.24.843c1.6-2.356 5.037-2.843 7.333-1.12.266.2.633.2.9 0 2.297-1.721 5.733-1.234 7.335 1.12 1.006 1.479 1.248 3.525.636 5.436-1.336 3.84-4.859 6.517-8.419 8.762-3.56-2.176-7.088-4.949-8.414-8.762-.612-1.912-.373-3.958.63-5.436z",
  fill: "#313D53"
})));